import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';

import { useAPI } from '../../utils/api';
import { useDialog } from '../../utils/dialog';
import { useAuth } from '../../utils/auth';
import { Vertify } from '@alex_xu/react-slider-vertify';

const LoginPage = () => {
  const localStoredAccountCode = localStorage.getItem('ac');

  const [doesRememberAccountCode, setDoesRememberAccountCode] = useState(
    !!localStoredAccountCode || false
  );
  const [loginSuccessed, setLoginSuccessed] = useState(false);
  const [loginResult, setLoginResult] = useState();
  const [captchaValid, setCaptchaValid] = useState(false);

  const location = useLocation();
  const auth = useAuth();
  const dialog = useDialog();
  const api = useAPI();

  const useQuery = () => new URLSearchParams(location.search);
  const redirectPath = (useQuery().get('rp') || '').replace('_', '/') || '/';

  const login = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    if (captchaValid) {
      const parameters = {
        account: data.get('username'),
        password: data.get('password'),
        browserInfo: navigator.userAgent,
      };

      api
        .login(parameters)
        .then((result) => {
          if (result.sessionToken) {
            setLoginResult(result);
            setLoginSuccessed(true);
          } else {
            auth.signout({ resetLocalStorage: false });
            dialog.openAlert({
              message: '登入時發生錯誤，請再試一次或聯絡客服，謝謝。',
            });
          }
        })
        .catch(() => {});
    } else {
      dialog.openAlert({ message: '圖片驗證錯誤，請再試一次。' });
    }
  };

  useEffect(() => {
    if (!(loginSuccessed && loginResult)) return;

    const sessionToken = loginResult.sessionToken;
    const memberID = loginResult.memberID;
    const accountCode = loginResult.accountCode;
    const isAdmin = loginResult.isAdmin;

    if (doesRememberAccountCode) {
      localStorage.setItem('ac', accountCode);
      sessionStorage.setItem('st', sessionToken);
      sessionStorage.setItem('mi', memberID);
      sessionStorage.setItem('ac', accountCode);
      sessionStorage.setItem('ia', isAdmin);
    } else {
      localStorage.removeItem('ac');
      sessionStorage.setItem('st', sessionToken);
      sessionStorage.setItem('mi', memberID);
      sessionStorage.setItem('ac', accountCode);
      sessionStorage.setItem('ia', isAdmin);
    }

    auth.signin({
      sessionToken,
      redirectPath,
      memberID,
      accountCode,
      isAdmin,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginSuccessed, loginResult]);

  return (
    <>
      {loginSuccessed ? undefined : (
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              登入
            </Typography>
            <Box component="form" onSubmit={login} noValidate sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                label="帳號"
                name="username"
                autoComplete="username"
                defaultValue={localStoredAccountCode || ''}
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="密碼"
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <Link
                underline="none"
                href="/#/forgot-password"
                variant="body2"
                sx={{ display: 'block', textAlign: 'right' }}
              >
                忘記密碼？
              </Link>
              <Vertify
                width={320}
                height={160}
                imgUrl={'/photos/random'}
                refreshIcon={'/images/icons/refresh-icon.png'}
                onSuccess={() => setCaptchaValid(true)}
                onFail={() => setCaptchaValid(false)}
                onRefresh={() => setCaptchaValid(false)}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    value="remember"
                    color="primary"
                    onChange={(event) =>
                      setDoesRememberAccountCode(event.target.checked)
                    }
                    checked={doesRememberAccountCode}
                  />
                }
                label="我要記住"
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={{ mt: 3, mb: 3 }}
              >
                登入
              </Button>

              <Divider />
            </Box>
          </Box>
        </Container>
      )}
    </>
  );
};

export default LoginPage;
